<ng-container *transloco="let t;">
  <div class="card-header">
    <h4 class="card-title font-medium-1">{{ t('Forgotten documents (Dashboard forgotten documents widget title) - Forgotten documents') }}</h4>
  </div>
  <div class="card-body">
    @for(forgottenDocuments of (fetchForgottenDocuments$ | async); track forgottenDocuments){
      <div class="transaction-item">
        <div class="media align-items-center">
          <div class="avatar bg-light-danger rounded">
            <div class="avatar-content">
              <i class="feather font-medium-3 icon-file-text"></i>
            </div>
          </div>
          <div class="media-body">
            <h6 class="transaction-title activity-Links-h6"><a class="activity-Links" [routerLink]="['/documents']" [state]="{query:forgottenDocuments.document_number,document_id:forgottenDocuments.id}">{{forgottenDocuments.name}}</a></h6>
            <p class="text-muted mb-0 font-small-3">{{ forgottenDocuments?.document_type?.document_type }}</p>
          </div>
        </div>
        <div><small class="text-muted">{{ forgottenDocuments?.created_at | dateConversationPipe | async }}</small></div>
      </div>
    } @empty {
      <div class="mb-1 p-4 mt-1 text-center cc-no-recordsDiv">
        <p class="text-muted mb-0">{{ t('No records (general) - No records') }}</p>
      </div>
    }
  </div>
</ng-container>